import { ShareState } from '~/store/share/-types'

export default (): ShareState => ({
  activeLang: null,
  activePin: null,
  activePinCategory: null,
  activeSpace: null,
  sharableLink: null
})
